import MuiSwitch from "@mui/material/Switch";
const Checkbox = MuiSwitch;
export default Checkbox;
